// services/offHours.service.js
import { generateClient } from 'aws-amplify/api';
import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';

const client = generateClient();

/**
 * Get the current off-hours configuration
 * @returns {Promise<Object|null>} - Off-hours configuration or null if none exists
 */
export const getOffHoursConfig = async () => {
  const result = await client.graphql({
    query: queries.listOffHoursConfigs,
    variables: { limit: 1 }
  });
  
  const configs = result.data.listOffHoursConfigs.items || [];
  return configs.length > 0 ? configs[0] : null;
};

/**
 * Create a new off-hours configuration
 * @param {Object} input - Configuration data
 * @returns {Promise<Object>} - Created configuration
 */
export const createOffHoursConfig = async (input) => {
  const result = await client.graphql({
    query: mutations.createOffHoursConfig,
    variables: { input }
  });
  return result.data.createOffHoursConfig;
};

/**
 * Update an existing off-hours configuration
 * @param {Object} input - Configuration data with id
 * @returns {Promise<Object>} - Updated configuration
 */
export const updateOffHoursConfig = async (input) => {
  const result = await client.graphql({
    query: mutations.updateOffHoursConfig,
    variables: { input }
  });
  return result.data.updateOffHoursConfig;
};

/**
 * Get or create off-hours configuration
 * Creates a default configuration if none exists
 * @returns {Promise<Object>} - Off-hours configuration
 */
export const getOrCreateOffHoursConfig = async () => {
  const existingConfig = await getOffHoursConfig();
  
  if (existingConfig) {
    return existingConfig;
  }
  
  // Create default configuration
  const defaultConfig = {
    isEnabled: true,
    weekdayStartTime: "17:00",  // 5 PM
    weekdayEndTime: "09:00",    // 9 AM
    weekendStartTime: "17:00",  // 5 PM
    weekendEndTime: "09:00",    // 9 AM
    updatedBy: "system"
  };
  
  return createOffHoursConfig(defaultConfig);
};
